import { Modal, theme, Typography } from 'antd'
import { t } from 'i18next'
import SelectAuditTrailsComponent from './SelectAuditTrailsComponent'
import SelectTimePeriod, {
  SelectTimePeriodOnChangeParams,
  TimePeriodValue,
} from './SelectTimePeriod'

const { useToken } = theme
const { Text } = Typography

interface MainHeaderAuditTrailsModalProps {
  isVisible: boolean
  onClose: () => void
  onComponentChange: (value?: string) => void
  onTimePeriodChange: (value?: SelectTimePeriodOnChangeParams) => void
  componentValue: string
  timePeriodValue?: TimePeriodValue
}

const MainHeaderAuditTrailsModal = ({
  isVisible,
  onClose,
  onComponentChange,
  onTimePeriodChange,
  componentValue,
  timePeriodValue,
}: MainHeaderAuditTrailsModalProps) => {
  const { token } = useToken()

  return (
    <Modal
      title={t('mainHeader.auditTrailsFilter') || ''}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width="80%"
      style={{
        top: '20%',
      }}
      styles={{
        content: {
          backgroundColor: token.colorBgContainer,
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Text>{t('Type') || ''}</Text>
        <SelectAuditTrailsComponent
          onChange={onComponentChange}
          value={componentValue}
        />
        <Text>{t('Time Period') || ''}</Text>
        <SelectTimePeriod
          onChange={onTimePeriodChange}
          defaultValue={timePeriodValue}
        />
      </div>
    </Modal>
  )
}

export default MainHeaderAuditTrailsModal
